import React from "react";
import IndustryAI from "./components/IndustryAI";

export default function App() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <IndustryAI />
    </div>
  );
}
